import { BasicLayout, RouteView } from '@/layouts'
import { Router } from './types'
import type { RouteRecordRaw } from 'vue-router'

export const example: RouteRecordRaw[] =
    [
        {
            path: '/',
            name: 'Layout',
            component: BasicLayout,
            meta: { title: 'menu.home' },
            redirect: '/dashboard',
            children: [

                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import('@/views/dashboard/Workplace.vue'),
                    meta: { title: '工作台' }
                },
                // 教材列表-单元/章节管理
                {
                    path: '/textbook-list/unit-list',
                    name: 'UnitList',
                    component: () => import('@/views/Resource/Textbook/UnitList.vue'),
                    meta: { title: '单元列表' }
                },
                // 单词库-新增
                {
                    path: '/add-word',
                    name: 'AddWord',
                    component: () => import('@/views/Resource/WordBank/add.vue'),
                    meta: { title: '新增单词' }
                },
                // 模拟资源-新增
                {
                    path: '/add-simulation',
                    name: 'AddSimulation',
                    component: () => import('@/views/Resource/Simulated/add.vue'),
                    meta: { title: '新增模拟资源' }
                },
                // 模拟资源-详情
                {
                    path: '/simulation-detail',
                    name: 'SimulationDetail',
                    component: () => import('@/views/Resource/Simulated/detail.vue'),
                    meta: { title: '模拟资源详情' }
                },
                // 视频详情
                {
                    path: '/video-detail',
                    name: 'VideoDetail',
                    component: () => import('@/views/Resource/Video/detail.vue'),
                    meta: { title: '视频详情' }
                },
                // 新增视频
                {
                    path: '/video-add',
                    name: 'VideoAdd',
                    component: () => import('@/views/Resource/Video/add.vue'),
                    meta: { title: '新增视频' }
                },
                // 课件详情
                {
                    path: '/courseware-detail',
                    name: 'CoursewareDetail',
                    component: () => import('@/views/Resource/Courseware/detail.vue'),
                    meta: { title: '课件详情' }
                },
                // 新增课件
                {
                    path: '/courseware-add',
                    name: 'CoursewareAdd',
                    component: () => import('@/views/Resource/Courseware/add.vue'),
                    meta: { title: '新增课件' }
                },
                // 音频详情
                {
                    path: '/audio-detail',
                    name: 'AudioDetail',
                    component: () => import('@/views/Resource/Audio/detail.vue'),
                    meta: { title: '音频详情' }
                },
                // 新增课件
                {
                    path: '/audio-add',
                    name: 'AudioAdd',
                    component: () => import('@/views/Resource/Audio/add.vue'),
                    meta: { title: '新增音频' }
                },
                // 电子书详情
                {
                    path: '/ebook-detail',
                    name: 'EbookDetail',
                    component: () => import('@/views/Resource/Ebook/detail.vue'),
                    meta: { title: '电子书详情' }
                },
                // 新增电子书
                {
                    path: '/ebook-add',
                    name: 'EbookAdd',
                    component: () => import('@/views/Resource/Ebook/add.vue'),
                    meta: { title: '新增电子书' }
                },
                // 电子书目录管理
                {
                    path: '/catalogue-management',
                    name: 'CatalogueManagement',
                    component: () => import('@/views/Resource/Ebook/CatalogueManagement.vue'),
                    meta: { title: '电子书目录管理' }
                },
                // 新增专题课程
                {
                    path: '/add-specialized-courses',
                    name: 'AddSpecializedCourses',
                    component: () => import('@/views/Resource/SpecializedCourses/add.vue'),
                    meta: { title: '新增专题课程' }
                },
                // 专题课程目录管理
                {
                    path: '/courses-chapter-management',
                    name: 'CoursesChapterManagement',
                    component: () => import('@/views/Resource/SpecializedCourses/ChapterManagement.vue'),
                    meta: { title: '专题课程目录管理' }
                },
                // 专题课程详情
                {
                    path: '/specialized-courses-detail',
                    name: 'SpecializedCoursesDetail',
                    component: () => import('@/views/Resource/SpecializedCourses/detail.vue'),
                    meta: { title: '专题课程详情' }
                },
                // 专题课程查看评价
                {
                    path: '/specialized-courses-comment',
                    name: 'SpecializedCoursesComment',
                    component: () => import('@/views/Resource/SpecializedCourses/CommentRecord.vue'),
                    meta: { title: '专题课程查看评价' }
                }
            ]
        },
        // 登录
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/403',
            name: '403',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403.vue'),
            meta: { title: 'menu.exception.not-permission' }
        },
        {
            path: '/404',
            name: '404',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404.vue'),
            meta: { title: 'menu.exception.not-find' }
        },
        {
            path: '/500',
            name: '500',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500.vue'),
            meta: { title: 'menu.exception.server-error' }
        }
    ]
